module.exports = Transform;

function Transform() {
  this.x = 0;
  this.y = 0;
  this.scale = 1;
}



//////////////////
// WEBPACK FOOTER
// ./~/panzoom/lib/transform.js
// module id = fdnF
// module chunks = 3